// src/pages/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser, registerUser } from "../api";

const EXAMS = ["IBPS PO","IBPS Clerk","SBI PO","SBI Clerk","SSC CGL","RRB NTPC"];

export default function Login() {
  const navigate = useNavigate();
  const [mode, setMode]       = useState("login");
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");
  const [form, setForm]       = useState({ name:"", email:"", password:"", targetExam:"IBPS PO" });

  function update(e) { setForm(f => ({ ...f, [e.target.name]: e.target.value })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const data = mode === "login"
        ? await loginUser(form.email, form.password)
        : await registerUser(form.name, form.email, form.password, form.targetExam);

      localStorage.setItem("token",    data.token);
      localStorage.setItem("userId",   data.userId);
      localStorage.setItem("userName", data.name);
      localStorage.setItem("targetExam", data.targetExam);
      navigate("/");
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/logo.png" alt="PrepAct" className="login-brand-img-main" />

        <div className="mode-toggle">
          <button className={`toggle-btn${mode === "login" ? " active" : ""}`} onClick={() => setMode("login")}>Login</button>
          <button className={`toggle-btn${mode === "register" ? " active" : ""}`} onClick={() => setMode("register")}>Register</button>
        </div>

        <form onSubmit={handleSubmit}>
          {mode === "register" && (
            <>
              <div className="form-group">
                <label className="form-label">Full name</label>
                <input className="form-input" name="name" placeholder="Arjun Kumar" value={form.name} onChange={update} required />
              </div>
              <div className="form-group">
                <label className="form-label">Target exam</label>
                <select className="form-input" name="targetExam" value={form.targetExam} onChange={update}>
                  {EXAMS.map(e => <option key={e}>{e}</option>)}
                </select>
              </div>
            </>
          )}
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" name="email" type="email" placeholder="you@email.com" value={form.email} onChange={update} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-input" name="password" type="password" placeholder="••••••••" value={form.password} onChange={update} required />
          </div>

          {error && <div className="error-box">{error}</div>}

          <button type="submit" className="btn btn-dark btn-block" disabled={loading} style={{ marginTop: 8 }}>
            {loading ? "Please wait…" : mode === "login" ? "Login" : "Create account"}
          </button>
        </form>
      </div>
    </div>
  );
}
